module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-11.e18d4552.png";